import {useCommerceAPI} from '../commerce-api/contexts'
import {usePageProductsCache} from '../hoc/with-page-products-cache'

/**
 * Hook to get function to obtain product from api.shopperProducts.getProduct that caches the results in memory.
 *
 * @returns {function({parameters: {id: string}}): Promise<Object>}
 */
const useCachedProduct = () => {
    const api = useCommerceAPI()
    const productsCache = usePageProductsCache()

    return productsCache?.getProduct || api.shopperProducts.getProduct
}

export default useCachedProduct
